<template>
  <div v-if="show" id="ie-notice" class="bg-warning">
    <div class="row no-gutters">
      <div class="col-12">
        <div class="alert alert-warning m-0 text-center rounded-0">
          <p class="m-0">
            <strong>Internet Explorer is not a supported browser.</strong>
            Please switch to a modern browser such as Chrome, Firefox or Safari.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BrowserDetect from "../../helpers/BrowserDetect";
export default {
  computed: {
    show() {
      return BrowserDetect.isIE();
    },
  },
};
</script>